/**
 * OrderItemCard — displays a parsed order item with selection toggle.
 * Shows item name, brand, price, size, color, category, retailer,
 * classification confidence, image preview, and source email subject.
 */

import { Icon } from 'semantic-ui-react';

const getCategoryIcon = (cat) => {
  const mapping = {
    dress: 'star',
    top: 'bookmark',
    bottom: 'cut',
    shoes: 'step forward',
    bag: 'shopping bag',
    accessory: 'gem',
    outerwear: 'umbrella',
    other: 'tag'
  };
  return mapping[cat] || 'tag';
};

const getCategoryLabel = (cat) => {
  const labels = {
    dress: 'Dress',
    top: 'Top',
    bottom: 'Bottom',
    shoes: 'Shoes',
    bag: 'Bag',
    accessory: 'Accessory',
    outerwear: 'Outerwear',
    other: 'Fashion'
  };
  return labels[cat] || 'Fashion';
};

const OrderItemCard = ({ item, selected, onToggle }) => {
  return (
    <div
      className={`order-item-card ${selected ? 'selected' : ''}`}
      onClick={() => onToggle(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onToggle(item); }}
    >
      {/* Selection indicator */}
      <div className="order-item-checkbox">
        <Icon
          name={selected ? 'check square' : 'square outline'}
          color={selected ? 'teal' : 'grey'}
        />
      </div>

      {/* Item image or category icon */}
      <div className="order-item-image">
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item.itemName}
            onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
          />
        ) : null}
        <div className="order-item-image-placeholder" style={item.imageUrl ? { display: 'none' } : {}}>
          <Icon name={getCategoryIcon(item.category)} size="large" />
        </div>
      </div>

      {/* Item details */}
      <div className="order-item-details">
        <div className="order-item-name">{item.itemName}</div>
        {item.brand && <div className="order-item-brand">{item.brand}</div>}
        <div className="order-item-meta">
          {item.retailer && <span className="order-item-retailer">{item.retailer}</span>}
          {item.size && <span className="order-item-size">Size {item.size}</span>}
          {item.color && <span className="order-item-color">{item.color}</span>}
        </div>
        {item.orderNumber && (
          <div className="order-item-source">Order #{item.orderNumber}</div>
        )}
      </div>

      {/* Right column: category + price */}
      <div className="order-item-right">
        <span className={`order-item-category ${item.category}`}>
          {getCategoryLabel(item.category)}
        </span>
        {item.price?.amount > 0 && (
          <span className="order-item-price">
            {item.price.currency === 'USD' ? '$' : item.price.currency}
            {item.price.amount.toFixed(2)}
          </span>
        )}
        {item.orderDate && (
          <span className="order-item-date">{item.orderDate}</span>
        )}
      </div>
    </div>
  );
};

export default OrderItemCard;
